import { useHistory } from 'react-router';
import { Image, Group } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import useFetchProjectCountsQuery from '@projects/queries/useFetchProjectCountsQuery';
import IconButton from 'src/components/UI/IconButton/IconButton';
import { TEXT_GREY } from 'src/styles/colors';
import NavigationPanelButton from '../NavigationPanelButton/NavigationPanelButton';
import useHasWorkspaceWithCustomBranding from '../../../workspaces/hooks/useHasWorkspaceWithCustomBranding';
import EmptyPlaceholder from './EmptyPlaceholder/EmptyPlaceholder';
import SkeletonLoader from './SkeletonLoader/SkeletonLoader';
import Section from './Section/Section';

import Logo from '../../../../../assets/img/icons/vb-logo-gray.svg';

import './NavigationPanel.scss';

const NavigationPanel = () => {
	const history = useHistory();
	const { data: projectCounts } = useFetchProjectCountsQuery();
	const hasWorkspaceWithCustomBranding = useHasWorkspaceWithCustomBranding();

	const navigateToDashboard = () => history.replace( '/projects' );

	const renderPanelContent = () => {
		if ( !projectCounts ) return <SkeletonLoader />;

		const hasActiveProjects = projectCounts.active > 0;
		const hasHiddenProjects = projectCounts.archived > 0;

		if ( !hasActiveProjects && !hasHiddenProjects ) return <EmptyPlaceholder />;

		return (
			<>
				{hasActiveProjects && <Section name="Active" projectStatus="active" />}
				{hasHiddenProjects && <Section name="Hidden" projectStatus="hidden" />}
			</>
		);
	}

	return (
		<div className="NavigationPanel">
			<div className="header">
				<div className="logo">
					{!hasWorkspaceWithCustomBranding && (
						<IconButton
							icon="vb-dark"
							size={24}
							onClick={navigateToDashboard}
							testID="vb-logo"
						/>
					)}
					<button onClick={navigateToDashboard}>
						<h3>My projects</h3>
					</button>
				</div>
				<NavigationPanelButton action="close" color={TEXT_GREY} />
			</div>
			<div className="content">
				{renderPanelContent()}
			</div>
			{hasWorkspaceWithCustomBranding && (
				<Group className="footer" spacing="4px" align="center" position="center" p="10px 14px 12px">
					<Text color="gray.6">Powered by</Text>
					<Image src={Logo} alt="VeryBusy logo" width={82} height={20} fit="contain" />
				</Group>
			)}
		</div>
	);
}

export default NavigationPanel;
